<template>
  <div class="page-container">
    <!-- Step 1: Email Entry & OTP Request -->
    <div v-if="step === 1">
      <SupportInstruction />
      <OTPForm @otpSent="handleOTPRequest" />
    </div>

    <!-- Step 2: OTP + Message Submission -->
    <div v-if="step === 2">
      <FeedbackForm :email="userEmail" @submitted="handleFeedbackSubmitted" />
    </div>

    <!-- Step 3: Confirmation -->
    <div v-if="step === 3">
      <CompletedSupportRequest
          :message="submittedMessage"
          @reset="resetForm"
      />
    </div>
  </div>
</template>

<script>
import SupportInstruction from '@/components/usr_support/SupportInstruction.vue';
import OTPForm from '@/components/usr_support/OTPForm.vue';
import FeedbackForm from '@/components/usr_support/FeedbackForm.vue';
import CompletedSupportRequest from '@/components/usr_support/CompletedSupportRequest.vue';

export default {
  components: {
    SupportInstruction,
    OTPForm,
    FeedbackForm,
    CompletedSupportRequest,
  },
  data() {
    return {
      step: 1,
      userEmail: "me@jamesborder.com",
      submittedMessage: ""  // Add this to store the message
    };
  },
  methods: {
    handleOTPRequest(email) {
      this.userEmail = email;
      this.step = 2;
    },
    handleFeedbackSubmitted(message) {
      this.submittedMessage = message;
      this.step = 3;
    },
    resetForm() {
      this.step = 1;
      this.userEmail = null;
    }
  }
};
</script>

<style scoped>
.user-support {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}
</style>